// extracted by mini-css-extract-plugin
module.exports = {"threeFeatured":"styles_threeFeatured__2LFIG","articles":"styles_articles__J_Cp2","gc":"styles_gc__1_PaD"};